<div class="pointCF__field" [ngSwitch]="volyIntegrationActive">
  <label
    ppTooltip
    class="pointCF__label"
    ppTitle="{{ ppCustomField()?.label }}"
    [ppTrimTooltip]="true"
  >
    @switch (volyIntegrationActive) {
      @case (EIntegrationStatus.OFF) {
        <img class="pointCF__bulk-changes-field-icon" [src]="EIconPath.ICON_FIELDS_MULTI_LIST_24" />
      }

      @case (EIntegrationStatus.ON) {
        <img
          class="pointCF__bulk-changes-field-icon"
          [src]="EIconPath.ICON_INTEGRATION_VOLY_ACTIVE_SMALL"
        />
      }

      @case (EIntegrationStatus.DISABLED) {
        <img
          class="pointCF__bulk-changes-field-icon"
          [src]="EIconPath.ICON_INTEGRATION_VOLY_INACTIVE_SMALL"
        />
      }
    }
    -
    <span class="pointCF__label-container"> {{ ppCustomField()?.label }} </span>
  </label>

  <div class="pointCF__content" #list>
    <button
      #pointFieldsList
      type="button"
      [attr.aria-label]="'Select ' + ppCustomField()?.label"
      data-test="bulkListFieldInput"
      id="{{ 'cbulkMultiList' + ppFieldId().toString() }}"
      class="pointCF__input pointCF__input--list"
      [ngClass]="{ 'pointCF__input--focus': focused }"
      [class.pointCF__input--error]="error"
      (click)="showList()"
      [class.pointCF__input--disabled]="disabled"
      ppTooltip
      [ppTitle]="ppCustomField()?.lockedValue ? ('locked_by_admin' | ppTranslate) : ''"
    >
      @if (fieldValue) {
        <span>{{ fieldValue }}</span>
      } @else {
        <span class="placeholder-text">{{ 'select...' | ppTranslate }}</span>
      }
    </button>

    <pp-save-indicator [ppFocused]="focused" [ppFilled]="!!fieldValue" [ppUpdating]="updating">
    </pp-save-indicator>

    @if (ppCustomField().lockedValue) {
      <div class="pointCF__padlock">
        <pp-padlock-icon />
      </div>
    }
  </div>
</div>
